import { Injectable } from "@angular/core";
import { ChartColor, ChartOptions, ChartType, ChartDataSets } from "chart.js";
import { Label } from "ng2-charts";

@Injectable({
    providedIn: 'root',
  })
export class BeatblipUtils {
  static stringArrayToNumbers(dataNumbers: number[]) {
    const toNumbers = arr => arr.map(Number);
     return toNumbers(dataNumbers);
  }

    constructor(){}



    public barChartColors: ChartColor[] = [
        'rgb(92, 184, 92)',
        'rgb(217, 83, 79)',
        'rgb(236, 59, 15)',
        'rgb(240, 173, 78)',
         'rgb(91, 192, 222)', 
         'rgb(102, 205, 170)'
      ]
      public barChartOptions: ChartOptions = {
        responsive: true,
        legend: {
          display: true,
          position: 'right',
        }
      };
      charData: any=[];
      public barChartLabels: Label[];
      public barChartType: ChartType = 'pie';
      public barChartLegend = true;
      public barChartPlugins = [];
      public barChartData: ChartDataSets[]=[];
      public pieColor: ChartColor[]=[];
      chartList: Array<Chart> = [];
      blinkArry: any[]=[];
      numarray: Array<Number>=[];
      testLabels: any[] = [];




    copyToClipboard(item): void {
        let listener = (e: ClipboardEvent) => {
            e.clipboardData.setData('text/plain', (item));
            e.preventDefault();
        };
        document.addEventListener('copy', listener);
        document.execCommand('copy');
        document.removeEventListener('copy', listener);
      }


    chartDataSets(datasets): any {
        this.barChartLabels = ['Pass','Fail','Blocked','Inconclusive','Not Run','Skipped']
        this.barChartData = [{ data:  datasets,label: 'Bar Chart' ,backgroundColor: this.barChartColors,hoverBackgroundColor: this.barChartColors,hoverBorderColor: this.barChartColors}];
    }

    selectChartType(chartType): any {
        this.barChartType = chartType;
    }

   


}
